import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IOfferDetail, IOfferInsert, IOfferSearch, IOfferUpdate, IOfferExamine } from "./offerTypes";


class OfferService {
    async page(searchVo: IOfferSearch, config: object = {}) {
        const apiUrl = "/gtm/offer/listPage";
        return await httpRequest.post<IPage<IOfferDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/gtm/offer/findByIdOrCode/${id}`;
        return await httpRequest.get<IOfferDetail>(apiUrl);
    }
    async insert(insertVo: IOfferInsert) {
        const apiUrl = "/gtm/offer/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IOfferUpdate) {
        const apiUrl = "/gtm/offer/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    //作废
    async disable(id: string) {
        const apiUrl = `/gtm/offer/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // 转外贸合同
    async transferOffer(Vo: { "code": string, "shopCode": string }) {
        const apiUrl = "/gtm/offer/transfer";
        return await httpRequest.post<string>(apiUrl, Vo);
    }
    // 总监审核
    async examineManager(Vo: IOfferExamine) {
        const apiUrl = "/gtm/offer/examineManager";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }
    // 财务审核
    async examineReckoner(Vo: IOfferExamine) {
        const apiUrl = "/gtm/offer/examineReckoner";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }
    // 提交审核
    async submitOffer(id: string) {
        const apiUrl = `/gtm/offer/submit/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //商品导出
    async materialExport(searchVo: IOfferSearch) {
        const appPageUrl = "/gtm/offer/exportDetails";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //商品导出
    async materialExportExcel(searchVo: IOfferSearch) {
        const appPageUrl = "/gtm/offer/exportDetailsExcel";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }


    //导出
    async export(searchVo: IOfferSearch) {
        const appPageUrl = "/gtm/offer/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/offer/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    //下载导入详情模板
    async downloadDetailTpl() {
        const appPageUrl = "/gtm/offer/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //下载导入详情模板
    async downloadSupplierTpl(codes: string, shopCode: string) {
        const appPageUrl = `/gtm//offer/detail/downloadTpl/${codes}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }

    importDetail(code: string) {
        return `/gtm/offer/detail/import/${code}`
    }
    // 修改审批时间
    offerTime(updateVo: any){
        const apiUrl = `/gtm//audit/update`
        return   httpRequest.post<string>(apiUrl, updateVo);
    }

}

export const offerService = new OfferService();
